import React, {useState, useRef} from 'react';
import {useAuthUser, useSignOut} from "react-auth-kit";
import {useHistory} from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import AccountCircle from '@mui/icons-material/AccountCircle';
import MenuItem from '@mui/material/MenuItem';
import {styled} from '@mui/material/styles';
import {ClickAwayListener, Container, Grow, MenuList, Paper, Popper} from "@mui/material";
import {isDealerSite, requestLoader} from "../../utils/utils";

const userMenuStyling = {
    marginRight: 0,
    marginTop: {xs: '10px', sm: 0},
    display: 'flex',
    justifyContent: 'flex-end',
    maxWidth: {xs: '100%', sm: '33%'}
};

const GuestItem = styled(MenuItem)(({theme}) => ({
    fontSize: '1.4rem',
}));

const GuestBar = ({title, children}) => {
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);
    const history = useHistory();

    const auth = useAuthUser();
    const signOut = useSignOut();

    const displayRatings = isDealerSite() ? [1, 1003442] : [];
    const displayWaivers = isDealerSite() ? [1] : [];

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    };

    const goToMyBookings = () => {
        window.location = `${window.appBasename}/booking/my-bookings`;
    };

    const goToRatings = () => {
        window.location = `${window.appBasename}/manage/ratings`;
    };

    const goToWaivers = () => {
        window.location = `${window.appBasename}/manage/waivers`;
    };

    const goToMarketing = () => {
        window.location = `${window.appBasename}/customization`;
    };

    const goToFeedback = () => {
        window.location = `${window.appBasename}/ratings/my_ratings`;
    };
    const goToProfile = () => {
        window.location = `${window.appBasename}/account`;
    };
    const goToChangePassword = () => {
        window.location = `${window.appBasename}/auth/change_password`;
    };
    const goToWidgetApiKey = () => {
        window.location = `${window.appBasename}/booking/my-widget/get-apikey`;
    };

    const logout = async() => {
        await requestLoader('booking/logoutBack');
        signOut();
    };

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        }
    }

    // return focus to the button when we transitioned from !open -> open
    const prevOpen = React.useRef(open);
    React.useEffect(() => {
        // console.log(isDealerSite());
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }

        prevOpen.current = open;
    }, [open]);
    return (
        <div>
            <AppBar position="static">
                <Toolbar sx={{flexDirection: {xs: 'column', sm: 'row'}}}>
                    <Typography variant="h4" component="h4">
                        {title}
                    </Typography>
                    {children && <Container sx={{marginTop: {xs: '10px', sm: 0}}}>
                        {children}
                    </Container>}
                    <Container sx={userMenuStyling}>
                        <span style={{cursor: 'pointer'}}
                              onClick={handleToggle}>Hello, {auth().firstName} {auth().lastName}
                            <IconButton
                                aria-label="Current User"
                                ref={anchorRef}
                                aria-controls={open ? 'menu-list-grow' : undefined}
                                aria-haspopup="true"
                                color="inherit"
                                size="large"
                            >
                                <AccountCircle fontSize="large"/>
                            </IconButton>
                        </span>
                        <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal
                                style={{zIndex: 100}}>
                            {({TransitionProps, placement}) => (
                                <Grow
                                    {...TransitionProps}
                                    style={{transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'}}
                                >
                                    <Paper>
                                        <ClickAwayListener onClickAway={handleClose}>
                                            <MenuList autoFocusItem={open} id="menu-list-grow"
                                                      onKeyDown={handleListKeyDown}>
                                                <GuestItem onClick={goToMyBookings}>My Bookings</GuestItem>
                                                {/*<GuestItem onClick={handleClose}>Edit Profile</GuestItem>*/}
                                                {displayRatings.includes(auth().id) && <GuestItem onClick={goToRatings}>Trip Ratings</GuestItem>}
                                                {displayWaivers.includes(auth().id) && <GuestItem onClick={goToWaivers}>DC Waivers</GuestItem>}
                                                {isDealerSite() && <GuestItem onClick={goToWidgetApiKey}>Get Widget</GuestItem>}
												 {isDealerSite() && <GuestItem onClick={goToMarketing}>Marketing</GuestItem>}
												 {isDealerSite() && <GuestItem onClick={goToFeedback}>Guest Feedback</GuestItem>}
												 {isDealerSite() && <GuestItem onClick={goToProfile}>My Profile</GuestItem>}
												 {isDealerSite() && <GuestItem onClick={goToChangePassword}>Change Password</GuestItem>}
                                                <GuestItem onClick={logout}>Log Out</GuestItem>
                                            </MenuList>
                                        </ClickAwayListener>
                                    </Paper>
                                </Grow>
                            )}
                        </Popper>
                    </Container>
                </Toolbar>
            </AppBar>
        </div>
    );
};

export default GuestBar;